<template>
  <div style="overflow: hidden;padding-bottom: 30px">
    <div class="introduct" >

      <el-row id="a" >


        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12"  >
          <div  class="isPcNotes">

            <div >

              <el-col  id="jianjie" :class="{animation:animations}">
                <img src="../../assets/abouttit.png" alt="关于我们" title="关于我们">
                <p  ref="about" >

                  {{introduce}}
                </p>
              </el-col>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" >

          <div  style="overflow: hidden">

            <div >

              <el-col style="padding-right: 5px;width: 100%;;opacity: 0" class="factoryPic" :class="{animation:animations}">
                <div style="height: 35vh;"><img style="width: 100%;height: 100%" src="../../assets/about.jpg" alt="pic1" title="pic1"></div>
                <div style="height: 5px"></div>
                <div style="height: 35vh;"><img style="width: 100%;height: 100%" src="../../assets/about.jpg" alt="pic2" title="pic2"></div>
              </el-col>
            </div>
          </div>
        </el-col>


      </el-row>
    </div>
    <div class="nones enterprise_culture_header">
      <p>公司文化</p>
    </div>
    <div class="nones enterprise_culture">

      <el-row>
        <el-col :span="12" :offset="6">
          <div style="padding: 10px">
            <div class="block">
              <el-carousel :autoplay="true" indicator-position="none" arrow="never">
                <el-carousel-item v-for="item in enterprise_culture"   :key="item">
                  <div>
                    <ul style="overflow: hidden">
                      <li style="float: left;width: 30%;line-height: 2rem;text-align: right;color: #cccccc"><h2>
                        {{item.title}}</h2></li>
                      <li style="float: left;width: 20%;padding: 0 20px"><p style="border: 1px solid #ccc;width: 100%;margin-top: 1rem"></p></li>
                      <li style="float: left;width: 50%;color: #333" ><h2>{{item.detail}}</h2></li>
                    </ul>
                  </div>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
        </el-col>
        <el-col :span="12" :offset="6">
          <el-steps :active="active"  finish-status="success">
            <el-step title="我们的愿景"></el-step>
            <el-step title="我们的使命" ></el-step>
            <el-step title="我们的价值观"></el-step>
            <el-step title="我们的团队"></el-step>
            <el-step title="我们的客户"></el-step>
          </el-steps>

        </el-col>

      </el-row>


    </div>
    <div class="partners_div">
      <!--合作伙伴-->
      <el-row>
        <el-col :span="24" >

          <p class="partner_title">合作伙伴</p>



          <el-carousel indicator-position="none" loop="false"  interval="5000" v-show="isPC">
            <el-carousel-item ref="carousel" v-for="(index,item) in 2" :key="item" style="background-color: #ffffff !important;" >
              <ul class="partners">
                <li><img :src="partnersImg[4*item+0].url" :alt="item"></li>
                <li><img :src="partnersImg[4*item+1].url" alt=""></li>
                <li><img :src="partnersImg[4*item+2].url" alt=""></li>
                <li><img :src="partnersImg[4*item+3].url" alt=""></li>
              </ul>
            </el-carousel-item>
          </el-carousel>

          <el-carousel height="150px"  indicator-position="none" loop="false" interval="3000" v-show="!isPC">
            <el-carousel-item ref="carousel" v-for="(index,item) in 4" :key="item" style="background-color: #ffffff !important;" >

              <ul class="partners">
                <li><img :src="partnersImg[2*item+0].url" :alt="item"></li>
                <li><img :src="partnersImg[2*item+1].url" alt=""></li>

              </ul>
            </el-carousel-item>
          </el-carousel>

        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import request from "@/utils/request";
  export default {
    name: "Introduce",
    data(){
      return{
        active: 0,
        // enterprise_culture:[
        //     {title:"我们的愿景",detail:"成为行业内领先的企业，为员工和社会创造更多价值。"},
        //     {title:"我们的使命",detail:"通过创新和服务，为客户创造价值，为员工提供发展机会，为社会创造财富。"},
        //     {title:"我们的价值观",detail:"诚信，" + "创新，\n" + "团结，\n" + "奉献。"},
        //     {title:"我们的团队",detail:"我们的团队是一支充满活力、专业和热情的队伍。我们鼓励创新思维和积极态度，不断学习和成长。"},
        //     {title:"我们的客户",detail:"我们始终坚持以客户为中心，致力于提供优质的产品和服务。我们重视每一个客户的反馈和建议，不断改进和创新。我们相信只有满足客户的需求和期望，才能实现企业的长期发展。"},
        // ],
        animations: false,
        partnersImg:[
          {url:require("../../../src/assets/5f83e5066ab13f433efdcaed6338586.png")},{url:require("../../../src/assets/7eaba9f78ae608f3409cff0b6db5ce0.png")},
          {url:require("../../../src/assets/7ff6d0d5357c2822606e563c62dc73d.jpg")},{url:require("../../../src/assets/37a2fae04f959c3db0021e8bf1ae23e.png")},
          {url:require("../../../src/assets/53fb1a9dd4e8a873c6420acf1d2ff07.png")},{url:require("../../../src/assets/bfd1bec0c63d1317297541103a29330.jpg")},
          {url:require("../../../src/assets/c6bdc629c8167477bc67a2a1d8a3e50.png")},{url:require("../../../src/assets/2607f752514558aaafc941724c87e76.jpg")}]
        ,isPC:true,
        introduce:""
      }
    },
    methods:{
      scrolling(){

        let s= window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop
        this.p1H=this.$refs.about.offsetHeight;

        //需要更改
        if (s>100){


          this.animations=true;

        }

      },
      DestroyListener() {
        window.removeEventListener('scroll', this.scrolling);
      },
      _isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
      },
    },
    mounted() {
      if (this._isMobile()) {
        this.isPC=false;
      }
      setInterval(() => {
        // 2秒后跳转到/page2页面
        if (this.active++ > 3) this.active = 0;
      }, 3000);
      request.get("/about/cht").then(res =>{

        this.introduce = res.data.introduce;
      }).catch((res)=>{
      })
      window.addEventListener("scroll", this.scrolling);
    },



  }
</script>

<style scoped >
  .nones{
    display: none;
  }
  ul{
    list-style: none;
    overflow-x: hidden;
  }
  .introduct{
    padding: 100px 0 0 0;
    width: 100vw;

  }
  .enterprise_culture_header ,.partner_title{
    font-size: 2.5rem;
    color: #000000;
    font-family: HarmonyOS_Sans_SC_Medium;
    padding-bottom: 50px;
    padding-top: 50px;
    text-align: center;
  }
  .enterprise_culture{
    /*background:linear-gradient(90deg, #225EB7, #7DE3E3);*/
    /*position: relative;*/


  }

  >>>.enterprise_culture .el-step__title{
    color: #333333 !important;
    margin-left: -20px;
  }

  >>>.enterprise_culture .el-step__icon-inner{
    display: none !important;
  }

  >>>.enterprise_culture .el-step__icon{
    border-width: 6px;
    background-color: rgba(255,255,255,0.1);
    /*border-color: #ffffff !important;*/
  }

  >>>.enterprise_culture .el-step__line{
    left:21px!important;;
  }

  >>>.enterprise_culture .is-process{
    border-color: #333 !important;
  }




  .animation{
    opacity: 0;
    animation: moveUp 2s ease-in-out forwards;
  }
  .factoryPic img:nth-child(1){
    animation-delay: 1s;

  }
  .factoryPic img:nth-child(2){
    animation-delay: 3s;

  }
  .partners{
    display: -webkit-flex; /* Safari */
    -webkit-justify-content: space-between; /* Safari 6.1+ */
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    padding: 15px;
    overflow-y: hidden;

    height: 100%;
  }
  .partners li{
    width: 20vw;
    display: flex;
    display: -webkit-flex;
    height: 100%;
  }
  .partners li img{
    width: 100%;
    margin: auto 0;
    /*height: 100%;*/
  }
  .isPcNotes{
    padding-top: 30px;
  }
  .isPcNotes #jianjie{
    padding:0 120px;
    opacity: 0
  }
  .isPcNotes #jianjie p{
    line-height: 2.5rem;font-size: 1.2rem;
  }
  .partners_div{
    padding-top: 50px
  }
  @media screen and (max-width: 768px){
    .introduct{
      padding: 50px 0 0 0;
      width: 100vw;

    }
    .isPcNotes{
      padding-top: 0px;
    }
    .isPcNotes #jianjie{
      padding:10px;
      opacity: 0
    }
    .isPcNotes #jianjie p{
      line-height: 2rem;
      font-size:1rem;
    }

    .partners_div p{
      padding-top: 30px
    }
    .enterprise_culture_header ,.partner_title{
      font-size: 2rem;
      color: #000000;
      font-family: HarmonyOS_Sans_SC_Medium;
      padding-bottom: 50px;
      padding-top: 50px;
      text-align: center;
    }
    .partners li{
      width: 45vw;
      display: flex;
      padding: 5px;
      display: -webkit-flex;
    }
    .partners{
      display: -webkit-flex; /* Safari */
      -webkit-justify-content: space-between; /* Safari 6.1+ */
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      -webkit-box-pack: justify;
      padding: 15px;
      overflow-y: hidden;
    }


  }
</style>